import type { EmissoesParaMeuCNPJResposta } from "../../../services/emissoesParaMeuCNPJ"

export enum EmissoesParaMeuCNPJActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_DATA_INICIAL = "ATUALIZAR_DATA_INICIAL",
    ATUALIZAR_DATA_FINAL = "ATUALIZAR_DATA_FINAL",
}

export type EmissoesParaMeuCNPJActions =
    | { type: EmissoesParaMeuCNPJActionsTypes.CARREGAR; payload: EmissoesParaMeuCNPJResposta }
    | { type: EmissoesParaMeuCNPJActionsTypes.ATUALIZAR_DATA_INICIAL; payload: string }
    | { type: EmissoesParaMeuCNPJActionsTypes.ATUALIZAR_DATA_FINAL; payload: string }
